<template>
    <div class="account-analysis-page">
        <!-- 空状态 -->
        <div v-if="isEmpty" class="empty-container">
            <div class="empty-box">
                <img src="@/assets/images/app-pages/recordEmpty.png" alt="" class="empty-img">
            </div>
            <div class="empty-label">
                <div class="label-text">{{ $t('accountAnalysis.a00002') }}</div>
            </div>
        </div>

        <!-- 加载状态 -->
        <div v-if="isLoading" class="loading-container">
            <div class="loading-box">
                <van-loading type="spinner" size="24px" />
                <div class="loading-text">{{ $t('accountAnalysis.a00008') }}...</div>
            </div>
        </div>

        <!-- 内容区域 -->
        <div v-if="!isEmpty && !isLoading">
            <!-- 顶部背景装饰区 -->
            <div class="bg-top" v-if="false"></div>

            <!-- 账户卡片轮播区 -->
            <div class="account-swipe" v-if="false">
                <swiper ref="mySwiper" :options="swiperOptions" class="account-swiper" @slideChange="handleSlideChange">
                    <swiper-slide v-for="(item, index) in accountList" :key="index" class="swiper-card-wrapper">
                        <div class="swipe-card" :class="{ 'active-card': currentSwipeIndex === index }">
                            <div class="card-top">
                                <img :src="item.avatar" alt="" class="account-logo">
                                <div class="card-right">
                                    <h3 class="card-title">
                                        <div class="futures-name">{{ item.futuresName }}</div>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>

            <!-- Tab区域 -->
            <div class="van-tabs-box" v-if="false">
                <!-- 更新时间 -->
                <div class="update-time">
                    更新时间：<span>{{ updateTime || '--' }}</span>
                </div>

                <!-- Tab切换 -->
                <van-tabs v-model="currentTab"
                    class="van-tabs-bg hairline hairline-position-top88 hairline-color-eee" @change="handleTabChange">
                    <van-tab v-for="tab in tabList" :key="tab.name" :title="tab.title" :name="tab.name">
                        <!-- 加载状态 -->
                        <div v-show="tab.name === '1' ? fundInfoIsLoading : statisticsInfoIsLoading"
                            class="info-loading-box">
                            <div class="loading-content">
                                <van-loading type="spinner" />
                                <div class="info-loading-text">生成中</div>
                            </div>
                        </div>

                        <!-- 数据展示 -->
                        <div v-show="tab.name === '1' ? !fundInfoIsLoading : !statisticsInfoIsLoading" class="info-box">
                            <div v-for="(item, index) in tab.name === '1' ? fundInfoList : statisticsInfoList"
                                :key="index" class="info-item"
                                :class="{ 'hairline hairline-position-bottom hairline-color-eee': index < (tab.name === '1' ? fundInfoList.length - 1 : statisticsInfoList.length - 1) }">
                                <div class="item-label">
                                    <span v-if="item.prefix" class="span-mr">{{ item.prefix }}</span>{{ item.label }}
                                </div>
                                <div class="item-value font-bold">{{ item.value }}</div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>

            <!-- 图表展示区 -->
            <div class="chart-container">
                <!-- 统计时间 -->
                <div class="chart-time">
                    {{ $t('accountAnalysis.a00003') }}：{{ updateTime }}
                </div>
                <!-- 权益走势图 -->
                <div class="equity-chart-section">
                    <div class="chart-title">{{ $t('accountAnalysis.a00004') }}</div>
                    <equity-chart :chartData="chartData"></equity-chart>
                </div>
                <!-- 累计净值图 -->
                <div class="profit-chart-section">
                    <div class="chart-title">{{ $t('accountAnalysis.a00005') }}</div>
                    <profit-chart :chartData="chartData"></profit-chart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from 'vant'
import EquityChart from './components/equityChart.vue'
import ProfitChart from './components/profitChart.vue'

export default {
    name: 'AccountAnalysis',
    components: {
        [Loading.name]: Loading,
        EquityChart,
        ProfitChart
    },
    data() {
        return {
            isEmpty: false,
            isLoading: true,
            updateTime: '',
            // 当前账户的图表数据
            chartData: []
        }
    },
    created() {
        // 获取账户数据
        // this.getAccountData()
        // 获取图表数据
        this.fetchChartData()
    },
    computed: {},
    mounted() {
        this.init()
    },
    methods: {
        // 初始化
        init() {
            // 隐藏滑动交互逻辑，不再调用loadAccountData
            // if (this.accountList.length > 0) {
            //     this.loadAccountData(0)
            // } else {
            //     this.isEmpty = true
            // }
        },

        // 获取账户数据
        async getAccountData() {
            // 获取账户列表
            const accountList = await this.$apis.getAccountLists()
            
        },
        // 获取图表数据
        async fetchChartData() {
            // 从URL参数获取account_no
            const accountNo = this.$route.query.account_no
            
            // 开始加载
            this.isLoading = true
            this.isEmpty = false
            
            try {
                const chartData = await this.$apis.queryChartData({ account_no: accountNo, count: 10000 })
                
                // 将API返回的数据赋值给chartData
                if (chartData && chartData.datas && chartData.datas.length > 0) {
                    this.chartData = chartData.datas
                    // 统计时间取图表数据的第一个date
                    this.updateTime = chartData.datas[0].date || ''
                    this.isEmpty = false
                } else {
                    // 没有数据时显示空状态
                    this.isEmpty = true
                }
            } catch (error) {
                // 请求失败时显示空状态
                this.isEmpty = true
            } finally {
                // 结束加载
                this.isLoading = false
            }
        },
        // Tab切换事件
        handleTabChange() {
            
            // Tab切换只控制显示，不重新加载数据
        }
    }
}
</script>

<style scoped lang="less">
.account-analysis-page {
    background-color: #f9fafc;
    min-height: 100vh;

    // 空状态
    .empty-container {
        min-height: 750px;
    }

    // 加载状态
    .loading-container {
        min-height: 750px;
        display: flex;
        justify-content: center;
        align-items: center;

        .loading-box {
            text-align: center;

            .loading-text {
                margin-top: 20px;
                font-size: 28px;
                color: #888888;
            }
        }
    }

    .empty-box {
        width: 100%;
        text-align: center;

        .empty-img {
            width: 240px;
            height: auto;
            margin-top: 170px;
        }
    }

    .empty-label {
        width: 100%;
        font-weight: 400;
        color: #444;
        font-size: 28px;
        margin-top: 56px;

        .label-text {
            width: 500px;
            margin: 0 auto;
            text-align: center;
        }
    }

    // 顶部背景装饰区
    .bg-top {
        height: 138px;
        background-image: url('../../../assets/images/app-pages/account-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center center;
    }

    // 账户卡片轮播区
    .account-swipe {
        margin-top: -268px;
        padding: 180px 0 20px 0;

        .account-swiper {
            width: 100%;
            overflow: hidden;
        }

        :deep(.swiper-slide) {
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0px 0px 16px 0px rgba(28, 9, 85, 0.1);
            transition: transform 300ms;
            transform: scale(0.92);

            &.swiper-slide-active {
                transform: scale(1);
            }
        }
    }

    .swipe-card {
        padding: 24px 30px 23px 18px;
        background-image: url('../../../assets/images/app-pages/account-card-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center center;
        height: 61px;
    }

    .card-top {
        display: flex;
        align-items: center;

        .account-logo {
            width: 80px;
            height: 80px;
            border-radius: 4px;
        }

        .card-right {
            flex: 1;
            padding-left: 8px;

            .card-title {
                font-size: 32px;
                color: #424242;
                line-height: 44px;
                margin: 0;

                .futures-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 520px;
                }

                .account-id {
                    font-size: 28px;
                    color: #666666;
                    font-weight: normal;
                }

                .account-icon {
                    width: 44px;
                    height: 44px;
                    vertical-align: top;
                    float: right;
                    margin-left: 8px;
                }
            }
        }
    }

    // Tab区域
    .van-tabs-box {
        background: #fafafa;
        padding-bottom: 20px;
    }

    .update-time {
        font-size: 24px;
        text-align: right;
        width: 100%;
        line-height: 2;
        color: #888888;
        background: #fff;

        span {
            padding-left: 10px;
            padding-right: 20px;
        }
    }

    .van-tabs-bg {
        background: #fff;
    }

    // hairline 样式
    .hairline {
        position: relative;

        &::after {
            content: '';
            position: absolute;
            height: 1px;
            width: 100%;
            transform: scaleY(0.5);
            transform-origin: 0 0;
        }
    }

    .hairline-position-top88 {
        &::after {
            top: 88px;
            left: 0;
        }
    }

    .hairline-position-bottom {
        &::after {
            bottom: 0;
            left: 0;
        }
    }

    .hairline-color-eee {
        &::after {
            background-color: #eee;
        }
    }

    // Tab样式
    /deep/ .van-tabs__line {
        width: 60px !important;
        background: #0c28c4;
        border-radius: 4px;
    }

    /deep/ .van-tab {
        color: #888888;
        font-size: 28px;
    }

    /deep/ .van-tab--active {
        color: #444444;
        font-weight: bold;
    }

    // 加载状态
    .info-loading-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 460px;

        .loading-content {
            text-align: center;
        }

        .van-loading {
            display: flex;
            justify-content: center;
        }

        .info-loading-text {
            margin-top: 30px;
            font-size: 28px;
            color: #888888;
        }
    }

    // 数据列表
    .info-box {
        font-size: 28px;

        .font-bold {
            font-weight: 500;
        }

        .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 90px;
            padding: 0 32px 0 26px;

            &:last-child {
                border-bottom: none;
            }

            .item-label {
                color: #888888;
            }

            .item-value {
                color: #444444;
            }

            .span-mr {
                margin-right: 4px;
            }
        }
    }

    .chart-time {
        color: #747377;
        font-size: 28px;
        padding: 20px 32px 0px;
        text-align: right;
        font-weight: 400;
        line-height: 28px;
    }

    // 权益图表区域
    .equity-chart-section {
        .chart-title {
            font-size: 32px;
            color: #17161C;
            font-weight: 600;
            padding: 0 40px;
            height: 80px;
            line-height: 80px;
        }
    }

    // 累计净值图表区域
    .profit-chart-section {
        margin-top: 40px;
        .chart-title {
            font-size: 32px;
            color: #17161C;
            font-weight: 600;
            padding: 0 40px;
            height: 88px;
            line-height: 88px;
        }
    }
}
</style>
